import BulkActionsConfirmActionStepInlineConfirmation from "components/BulkActions/ConfirmActionStep/InlineConfirmation";

import { FlowsProjectRolesBulkActionsConfirmActionStepProps } from "../types";

const FlowsProjectDetailsRolesBulkActionsConfirmActionStepDefault = ({
  action,
  bulkActionsVariant,
  onConfirm,
  onCancel,
  customConfirmationMessage,
}: FlowsProjectRolesBulkActionsConfirmActionStepProps) => {
  return (
    <BulkActionsConfirmActionStepInlineConfirmation
      variant={bulkActionsVariant}
      actionLabel={action.title.toLowerCase()}
      onConfirm={() =>
        onConfirm(null, {
          view: bulkActionsVariant,
          metadata: {},
        })
      }
      onCancel={onCancel}
      customConfirmationMessage={customConfirmationMessage}
    />
  );
};

export default FlowsProjectDetailsRolesBulkActionsConfirmActionStepDefault;
